import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { IoMdCloseCircleOutline } from "react-icons/io";
import commonActions from "../../Redux/common/actions";
import { useDispatch, useSelector } from "react-redux";
import { IconButton } from "@mui/material";

export default function RemainingTimeModal({ currentSection, nextSection }) {
  // Derieved variables
  const dispatch = useDispatch();
  const { showModal } = useSelector((state) => state.commonReducer);

  // Helper functions
  const handleClose = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: false, type: null, method: "A", data: null },
    });
  };

  return (
    <>
      <Dialog
        minWidth="lg"
        open={showModal?.show && showModal?.method === "A"}
        onClose={handleClose}
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding: "8px",
            backgroundColor: "rgba(240, 240, 251, 1)",
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 0,
              right: 4,
              color: "#000",
            }}
          >
            <IoMdCloseCircleOutline />
          </IconButton>
          {currentSection &&
            nextSection &&
            currentSection !== "" &&
            nextSection !== "" && (
              <DialogContentText sx={{ fontSize: 28, textAlign: "center" }}>
                <b>{currentSection}</b> Ended and <br /> <b>{nextSection}</b>{" "}
                Started
              </DialogContentText>
            )}
        </DialogContent>
      </Dialog>
    </>
  );
}
